<template>
  <div :class="$style.bgWrap">
    <div v-if="this.$store.state.apiPost === '1'">
      <img :class="$style.imgBg" :src="bg">
    </div>
    <div v-if="this.$store.state.apiPost && this.$store.state.apiPost != '1' ">
      <img :class="$style.imgBg2" :src="this.$store.state.apiPost.url" v-if="this.$store.state.apiPost.type === 1">
       <img :class="$style.imgBg2" :src="this.$store.state.apiPost.thumbnail" v-if="this.$store.state.apiPost.type === 5">
      <video controls="controls" controlslist="nodownload nofullscreen noremoteplayback" disablePictureInPicture="true" :class="$style.videoBg" :poster="this.$store.state.apiPost.thumbnail" v-if="this.$store.state.apiPost.type != 1 && this.$store.state.apiPost.type != 5">
        <source :src="this.$store.state.apiPost.url" type="video/mp4" />
      </video>
    </div>

    <td th:if="${post.type!=1}">

      <img width="280" th:src="${post.thumbnail}" th:if="${post.type==5}" />
    </td>

    <Button position='bottom'></Button>
    <!-- <span><span :class="$style.more">See more</span></p> -->
  </div>
</template>

<script>
import bg from '../assets/imgs/bg.png'
import Button from './Button'
export default {
  data () {
    return {
      bg: bg,
      apiPost: ''
    }
  },
  components: {
    Button
  },

}

</script>

<style module lang="scss">
.bgWrap {
    margin-bottom: 20px;
    .imgBg {
        // width: 350px;
        height: 189px;
        margin: 5px auto 5px auto;
    }
    .imgBg2 {
        // width: 350px;
        height: 360px;
        margin: 5px auto 5px auto;
    }
    p {
        margin: 8px auto 20px auto;
    }
    .videoBg {
       // width: 350px;
        height: 360px;
        margin: 5px auto 5px auto;
    }
    .more {
        background: url('../assets/imgs/ico-more.svg') right center no-repeat;
        background-size: 15%;
        color: #9b9ca1;
        padding-right: 20px;
        margin: 0 auto;
    }
}
</style>
